import(/* webpackMode: "eager", webpackExports: ["TeamMemberView"] */ "/vercel/path0/frontend_next/src/components/views/TeamMemberView.tsx");
